import React from "react";
import { Box, Typography, Button } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";

const steps = [
  ["No forms, just talk", "Ramble about yourself and your ideal match. We'll figure out the rest, no endless questionnaire required."],
  ["Review what we heard", "See what we picked up, and fix anything that's off."],
  ["Meet people between events", "We introduce you to others who've shown up in person, so it keeps going after the night ends."],
];

const CaptureIntro = ({ onStart, starting }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3, pb: 12, maxWidth: 480, mx: "auto" }}>
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: 3,
          bgcolor: "rgba(239,82,65,0.12)",
          color: "primary.main",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: 30 }} />
      </Box>

      <Typography sx={{ fontSize: 28, fontWeight: 600, lineHeight: 1.2, mb: 1.5 }}>
        Only people from{" "}
        <Box component="span" sx={{ color: "primary.main" }}>
          our events.
        </Box>
      </Typography>

      <Typography
        sx={{ fontSize: 15, color: "text.secondary", lineHeight: 1.5, mb: 3 }}
      >
        Everyone in the Matchmaker pool has shown up to one of our events. Real
        people, real intention, no random swipes. Tell us who you are and who
        you're looking for, and we'll introduce you between events.
      </Typography>

      <Box sx={{ mb: 4 }}>
        {steps.map(([heading, body], i) => (
          <Box key={heading} sx={{ display: "flex", gap: 1.5, py: 1 }}>
            <Box
              sx={{
                flexShrink: 0,
                width: 28,
                height: 28,
                borderRadius: "50%",
                bgcolor: "rgba(239,82,65,0.12)",
                color: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              {i + 1}
            </Box>
            <Box>
              <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                {heading}
              </Typography>
              <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                {body}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 1.25,
          p: 1.75,
          mb: 2,
          borderRadius: 2,
          bgcolor: "rgba(0,0,0,0.03)",
        }}
      >
        <InfoOutlinedIcon
          sx={{ fontSize: 20, color: "text.secondary", flexShrink: 0, mt: 0.25 }}
        />
        <Typography sx={{ fontSize: 13, color: "text.secondary", lineHeight: 1.5 }}>
          This is separate from your event profiles and completely optional. It
          has no effect on the events you attend or who you're matched with at
          them. It's simply an extra way for us to introduce you to people
          between events.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 1.25,
          p: 1.75,
          mb: 3,
          borderRadius: 2,
          bgcolor: "rgba(0,0,0,0.03)",
        }}
      >
        <LockOutlinedIcon
          sx={{ fontSize: 20, color: "text.secondary", flexShrink: 0, mt: 0.25 }}
        />
        <Typography sx={{ fontSize: 13, color: "text.secondary", lineHeight: 1.5 }}>
          Your privacy matters to us. Everything you share here stays
          confidential. We'll never show it to other members or share it with
          anyone. It's used only to help us connect you with people from our
          events.
        </Typography>
      </Box>

      <Button
        variant="contained"
        fullWidth
        size="large"
        onClick={onStart}
        disabled={starting}
      >
        {starting ? "Checking profile..." : "Get started"}
      </Button>
      <Button
        fullWidth
        sx={{ mt: 1 }}
        disabled={starting}
        onClick={() => navigate("/profile")}
      >
        Cancel
      </Button>
    </Box>
  );
};

export default CaptureIntro;
